import { Controller } from "@hotwired/stimulus"

// Files a task under a kind from its Facts sheet. The editor opens in place
// under the kind row; choosing a kind shows its reasons as chips that fill the
// reason field. Escape or Cancel closes it without saving.
export default class extends Controller {
  static targets = ["toggle", "panel", "search", "option", "chips", "reason", "reasonBox"]

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.renderChips()
    this.optionTargets.find((option) => option.querySelector("input").checked)?.scrollIntoView({ block: "nearest" })
    this.searchTarget.focus({ preventScroll: true })
  }

  close() {
    this.panelTarget.hidden = true
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.focus()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    this.optionTargets.forEach((option) => {
      option.hidden = query.length > 0 && !option.dataset.name.includes(query)
    })
  }

  choose() {
    this.renderChips()
  }

  typed() {
    this.markChosenChip()
  }

  renderChips() {
    const chosen = this.optionTargets.map((option) => option.querySelector("input")).find((input) => input.checked)
    const reasons = chosen ? JSON.parse(chosen.dataset.reasons || "[]") : []
    this.reasonBoxTarget.hidden = !chosen || chosen.value === ""
    this.chipsTarget.replaceChildren(...reasons.map((reason) => {
      const chip = document.createElement("button")
      chip.type = "button"
      chip.className = "kind-picker__chip"
      chip.textContent = reason
      chip.addEventListener("click", () => {
        this.reasonTarget.value = reason
        this.markChosenChip()
      })
      return chip
    }))
    this.markChosenChip()
  }

  markChosenChip() {
    const value = this.reasonTarget.value.trim()
    this.chipsTarget.querySelectorAll(".kind-picker__chip").forEach((chip) => {
      chip.setAttribute("aria-pressed", chip.textContent === value ? "true" : "false")
    })
  }
}
